import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoArrowBack } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";
import { fetchChatHistory, fetchTopupUser } from "../../services/api";

const ChatPayment = ({ person, onBack }) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadChatHistory = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const data = await fetchChatHistory(userId, person.id);
        setTransactions(data);
      } catch (err) {
        setError("Failed to load chat history.");
      } finally {
        setLoading(false);
      }
    };
    loadChatHistory();
  }, [person]);

  const handlePay = async () => {
    try {
      const data = await fetchTopupUser(person.id);
      if (data.payment_url) window.location.href = data.payment_url;
      else alert("Payment URL not found.");
    } catch {
      alert("Failed to start payment.");
    }
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={person.id}
        initial={{ y: "100%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: "100%", opacity: 0 }}
        transition={{ type: "spring", stiffness: 120, damping: 16 }}
        className="chatpay-container"
      >
        <motion.div className="chatpay-header">
          <button onClick={onBack} className="chatpay-back-btn">
            <IoArrowBack size={26} />
          </button>
          <div className="chatpay-user">
            <FaUserCircle className="chatpay-avatar" size={46} />
            <div>
              <h5 className="chatpay-username mb-0">{person.name}</h5>
              <small className="chatpay-userid">@user{person.id}</small>
            </div>
          </div>
        </motion.div>

        <div className="chatpay-history">
          {loading ? (
            <p className="chatpay-message text-muted">Loading transactions...</p>
          ) : error ? (
            <p className="chatpay-message text-danger">{error}</p>
          ) : transactions.length === 0 ? (
            <div className="chatpay-message text-muted">
              <p>No transactions yet with {person.name}.</p>
              <small>Start by making your first payment 💸</small>
            </div>
          ) : (
            transactions.map((txn) => (
              <motion.div
                key={txn.id}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.25 }}
                className={`chatpay-bubble-wrapper ${
                  txn.type === "sent"
                    ? "justify-content-end"
                    : "justify-content-start"
                }`}
              >
                <div
                  className={`chatpay-bubble ${
                    txn.type === "sent"
                      ? "chatpay-bubble-sent"
                      : "chatpay-bubble-received"
                  }`}
                >
                  <p className="fw-semibold mb-1">
                    {txn.type === "sent"
                      ? `You paid ₹${txn.amount}`
                      : `You received ₹${txn.amount}`}
                  </p>
                  <small
                    className={
                      txn.type === "sent"
                        ? "text-muted fw-normal"
                        : "text-muted fw-normal"
                    }
                  >
                    {txn.date}
                  </small>
                </div>
              </motion.div>
            ))
          )}
        </div>

        <div className="chatpay-footer">
          <motion.button
            whileTap={{ scale: 0.96 }}
            onClick={handlePay}
            className="chatpay-btn">Pay {person.name}
          </motion.button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ChatPayment;